var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$i18n.locale === _vm.deutsch_code)?_c('privacy-policy-de'):_c('privacy-policy')],1)}
var staticRenderFns = []

export { render, staticRenderFns }